import { 
    ACTUALIZAR_DIMENSIONES,
    ACTUALIZAR_SUBCUENTAS,
    ACTUALIZAR_SUBCUENTAS_DB,
    CARGANDO_SUBCUE,
    ERROR_SUBCUE,
    LIMPIAR_ERROR
} from "./subcuentasActions";

const subcuentasReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_DIMENSIONES:  {
            return {
                ...state,
                dimensiones: action.payload,
                cargando: false,
                error: ""
            }
        }
        case ACTUALIZAR_SUBCUENTAS:
        case ACTUALIZAR_SUBCUENTAS_DB: {
            return {
                ...state,
                subcuentas: action.payload,
                cargando: false,
                error: ""
            }
        }

        case CARGANDO_SUBCUE: {
            return {
                ...state,
                cargando: true,
                error: ""
            }
        }

        case ERROR_SUBCUE: {
            return {
                ...state,
                cargando: false,
                error: action.payload
            }
        }

        case LIMPIAR_ERROR: {
            return {
                ...state,
                error: ""
            }
        }

    }
}

export default subcuentasReducer;